<template>
	<div class="balance-card">
		<LayoutFlex padding="0" gap="var(--size-8)" align-items="flex-start">
			<Text font="--text-18-22-semi" color="--text-dark-primary">{{ title }}</Text>
			<Text v-if="description" font="--text-14-20-med" :color="KOVA.textSecondary">{{ description }}</Text>
		</LayoutFlex>
		<slot />
	</div>
</template>

<script setup lang="ts">
// "Your balance to end today is $X" card on top of /cancel/commitment/options (Figma 7415:17805).
// The default slot hosts the SupplyProgress bar.
import { LayoutFlex, Text } from '@simple-life-app/growth-ui-kova'
import { KOVA } from '@/designTokens'

defineProps<{
	title: string
	description?: string
}>()
</script>

<style scoped>
/* `status/purple/bg` of the Kova web palette, rgba(162, 38, 166, 0.1) — the DS violet is bluer. */
.balance-card {
	display: flex;
	flex-direction: column;
	gap: var(--size-16);
	width: 100%;
	padding: var(--size-20);
	background: rgba(162, 38, 166, 0.1);
	border-radius: var(--size-24);
}
</style>
